import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _UserEnrolledSkeleton;
import Loadable from "../../../../../../Loadable";
import UserEnrolledSkeleton from "./components/UserEnrolledSkeleton";
import { jsx as _jsx } from "react/jsx-runtime";
var LazyUserEnrolled = function LazyUserEnrolled(props) {
  return /*#__PURE__*/_jsx(Loadable, _objectSpread({
    Loader: _UserEnrolledSkeleton || (_UserEnrolledSkeleton = /*#__PURE__*/_jsx(UserEnrolledSkeleton, {
      withContainer: true
    })),
    module: function module() {
      return import( /* webpackChunkName: "learn-last-activity-b2b-enrolled" */"./UserEnrolled");
    }
  }, props));
};
export default LazyUserEnrolled;